import codes from "./errorCodes"

export default function ssoErrorHandler(code: string): any {
  switch (code) {
    case codes.InvalidCode:
      return "errors.PBInvalidCode"
    case codes.UserWithEmailHasSsoId:
      return "errors.PBSSOUserWithEmailHasSsoId"
    case codes.UserWithEmailDoesNotExist:
      return "errors.PBSSOUserWithEmailDoesNotExist"
    case codes.UnexpectedError:
      return "errors.PBSSOUnexpectedError"
    default:
      return ""
  }
}
